import { MemberEventsService } from '../../../services/member.events.service';
import { Component, Input, OnDestroy, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TrainingHistoryResponse, TrainingHistoryResponseArray } from '../../../../app/models/ss-api/responses/training.history.response';
import { Subscription } from 'rxjs';
import { EntityChangedArgs } from '../../../../app/managers/manager.base';
import { SortBot } from '../../../../app/helpers/sort';
import { MenuItem, Menu } from 'primeng/primeng';
import { ssApiService } from '../../../services/ss-api.service';
import { UpdateTrainingEventSubscriptionStatusesRequest, UpdateTrainingEventSubscriptionStatusesRequestArray } from '../../../models/ss-api/requests/update.training.event.subscription.statuses.request';
import { AttendanceStatusTypes } from '../../../models/domain/training.event.subscription';

@Component({
    selector: 'member-training',
    templateUrl: './member.training.component.html',
    styleUrls: ['./member.training.component.css']
})

export class MemberTrainingComponent implements OnInit, OnDestroy {
    private subscriptions = new Array<Subscription>();

    @Input('IsBusy') IsBusy: boolean = false;
    @Input('TrainingHistory') TrainingHistory: TrainingHistoryResponseArray;
    @Output('onRefresh') onRefresh: EventEmitter<string> = new EventEmitter();

    @ViewChild('statusMenu') statusMenu: Menu;
    statusMenuItems: MenuItem[] = [];
    private currentItem: TrainingHistoryResponse;

    TrainingHistorySearch: String;

    trainingHistoryResultRows: number = 25;
    firstResult: number = 0;
    lastResult: number = 24;

    constructor(private memberEvents: MemberEventsService, private router: Router, private api: ssApiService) {

    }

    SortBySignupDate() { this.TrainingHistory = SortBot.SortAuto(this.TrainingHistory, 'SignupDate'); }
    SortByClassDate() { this.TrainingHistory = SortBot.SortAuto(this.TrainingHistory, 'EventDateTime'); }
    SortByClassName() { this.TrainingHistory = SortBot.SortAuto(this.TrainingHistory, 'ClassName'); }
    SortByLicense() { this.TrainingHistory = SortBot.SortAuto(this.TrainingHistory, 'ProductName'); }
    SortByAttendanceStatus() { this.TrainingHistory = SortBot.SortAuto(this.TrainingHistory, 'AttendanceStatusType'); }

    ngOnInit() {
        this.SubscribeEvents();
    }

    ngOnDestroy() {
        this.UnsubscribeEvents();
    }

    OpenTrainingEvent(id) {
        this.router.navigate(['/training/calendar/' + id]);
    }

    OpenCertificate(cert) {
        //todo:  Update with live Reports URL before going live.
        //(<any>window).open('https://reports-api.structurestudios.com/PDF/Training/Certificate/false/product/' + cert.CertificateToken + '/' + cert.CertificateID);
        (<any>window).open('https://api-reports-ssdb3-node2.structurestudios.com/PDF/Training/Certificate/false/product/' + cert.CertificateToken + '/' + cert.CertificateID);
    }

    UnsubscribeEvents() {
        if (this.subscriptions != null)
            this.subscriptions.forEach((s) => { s.unsubscribe(); });
    }

    SubscribeEvents() {
        // memberevents
        let memberEvents = this.memberEvents.onNoteChanged.subscribe((args: EntityChangedArgs<any>) => {
            // this.CheckNoteChanged(args);
            return true;
        });
        this.subscriptions.push(memberEvents);
    }

    reloadTrainingHistory() {
        this.onRefresh.emit('');
    }

    formatForType(type) {
        switch (type) {
            case 1:
                return 'Registered';
            case 2:
                return 'Attended Class';
            case 3:
                return 'Cancelled';
            case 4:
                return 'Rescheduled';
            case 5:
                return 'No Show';
            }
    }

    paginateTrainingHistory(e) {
        this.firstResult = e.page * e.rows;
        this.lastResult = this.firstResult + e.rows;
    }

    showStatusMenu(event: Event, item: TrainingHistoryResponse) {
        this.currentItem = item;
        this.statusMenuItems = [
            {
                label: 'Set Status to Registered',
                command: () => this.updateStatus(AttendanceStatusTypes.Registered)
            },
            {
                label: 'Set Status to Attended',
                command: () => this.updateStatus(AttendanceStatusTypes.AttendedClass)
            },
            {
                label: 'Set Status to Cancelled',
                command: () => this.updateStatus(AttendanceStatusTypes.Cancelled)
            },
            {
                label: 'Set Status to Rescheduled',
                command: () => this.updateStatus(AttendanceStatusTypes.Rescheduled)
            },
            {
                label: 'Set Status to No Show',
                command: () => this.updateStatus(AttendanceStatusTypes.NoShow)
            }
        ];
        this.statusMenu.toggle(event);
    }

    updateStatus(newStatus: AttendanceStatusTypes) {
        let request = new UpdateTrainingEventSubscriptionStatusesRequestArray();
        let updateRequest = new UpdateTrainingEventSubscriptionStatusesRequest();
        updateRequest.TrainingEventSubscriptionID = this.currentItem.TrainingEventSubscriptionID as number;
        updateRequest.NewStatus = newStatus;
        request.push(updateRequest);

        let disposable = this.api.UpdateTrainingEventSubscriptionStatuses(request)
            .subscribe(response => {
                this.currentItem.AttendanceStatusType = newStatus;
                disposable.unsubscribe();
            });
    }

}
